import { render } from "./AppNavbar.vue?vue&type=template&id=a29fae88"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chmonya\\Desktop\\Обучалки\\vue.js\\15-crm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__